import { render, staticRenderFns } from "./WorkspacesCard.vue?vue&type=template&id=0d1255a0&scoped=true&lang=pug"
import script from "./WorkspacesCard.vue?vue&type=script&lang=js"
export * from "./WorkspacesCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspacesCard.vue?vue&type=style&index=0&id=0d1255a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1255a0",
  null
  
)

export default component.exports